import React from "react";
import { Card, CardContent, CardDescription, CardMeta, Label, Header } from "semantic-ui-react";
import {capitalizeFirstLetter} from "../../../utils/utils";

export const RelevantPublications = ({ profile }) => {
    const list = (() => {
        try {
            const raw = profile?.relevant_publications;
            return raw ? JSON.parse(raw) : [];
        } catch {
            return [];
        }
    })();

    if (!list.length > 0) {
        return <></>;
    }

    return (
        <Card fluid>
            <Card.Content>
                <Card.Header as="h2">{`Relevant Publications`}</Card.Header>
                <>
                    {list.map((publication, index) => (
                        <Card fluid key={index}>
                            <CardContent>
                                <Card.Header as="h2">{publication.title}</Card.Header>
                                <CardMeta>
                                    <span className="date">{publication.doi}</span>
                                </CardMeta>
                                <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
                                    {publication.keywords.split(" ").map((keyword) => {
                                        let aKeyword = keyword.replaceAll(",","");
                                        aKeyword = aKeyword.trim();
                                        return (
                                            <Label
                                                as='a'
                                                key={aKeyword}
                                                target='_blank'
                                                href={'/persons/search?q=user_profile.profile.relevant_publications%3A'+aKeyword}>
                                                {capitalizeFirstLetter(aKeyword)}
                                            </Label>
                                        );
                                    })}
                                </div>
                                <Header as="h4">Abstract</Header>
                                <CardDescription>{publication.abstract}</CardDescription>
                            </CardContent>
                        </Card>
                    ))}
                </>
            </Card.Content>
        </Card>
    );
};
